/* ============================================================
   assets/int-pdp-mobile.js               INTENTION — 2026-09-02
   Extracted verbatim from the <script> block that used to live inline in
   snippets/int-pdp-mobile.liquid. Read THAT file's header comment for the
   produced order, the size-radio rule and the quantity-block rule.

   ⚑ WHY IT MOVED: 25KB of inline script sat mid-document and the parser
   could not continue past it until it had been parsed. Loaded with `defer`
   it is fetched in parallel, blocks nothing, and is cached across pages.

   ⚑ SAFE TO DEFER because the script already ends with a readyState guard
   and only ever runs boot() at DOMContentLoaded. A deferred script executes
   after parsing completes and just before DOMContentLoaded fires, so boot()
   still sees a fully parsed document — in practice a touch EARLIER than
   before, never later. Do not remove the readyState guard: it is what makes
   this file safe to load either way.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intMobOrder) return;
  window.__intMobOrder = true;

  var MQ = '(max-width: 820px)';
  if (!window.matchMedia || !window.matchMedia(MQ).matches) return;

  function q(sel, root) { return (root || document).querySelector(sel); }

  /* ⚑ THE FITTER LIVES IN assets/int-pdp-title-fit.js NOW, and it is loaded
     NON-DEFERRED right after the title markup so the headline can be sized
     and shown at ~42% of the byte stream instead of waiting for this file.
     "Move the call, not the code": one implementation, two callers. If the
     small file somehow did not load, the title is still visible — its release
     class is added there and the order layer has already placed it — it just
     paints at the default size. */
  function fitTitle(wrap) {
    if (window.__intFitTitle) window.__intFitTitle(wrap);
  }

  function boot() {
    var media = q('.product__media__wrapper');
    var inner = q('.product__inner');
    if (!media || !inner) return;

    document.body.classList.add('int-mob-order');

    /* 0 ── the hero image height: OWNED BY CSS, NOT BY THIS FILE.
           `assets/int-pdp-mobile.css` sets, on .product__grid, the
           .flickity-viewport, .product__media and the .flickity-slider:
               height: 62vw !important; max-height: 320px !important;
               min-height: 0 !important; padding-bottom: 0 !important;
           and sets height/max-height 100% plus object-fit:contain on the inner
           boxes and the <img>. A stylesheet declaration marked !important beats
           any inline declaration that is not marked important, including every
           inline height Flickity writes onto its cells.

           ⚑ A gallery sizing function used to live here and re-assert the same
           numbers on a five point schedule. It was deleted on 2026-09-17 after
           being measured as a no-op: it computed
           min(round(innerWidth * 0.62), 320), which is the SAME value 62vw was
           already producing, and wrote it ~300 times per load (2,235 times on
           the framed print twin of this file, which has 120 media slides).
           Suppressing every one of those writes at the CSSOM level left the
           gallery at exactly 248/248/248 with the image box at 368x248 on both
           templates, and settled ~300ms sooner.
           Evidence: INTENTION_Shared/FINDINGS-who-owns-the-gallery-height-2026-09-17.md
           Do not add it back. If the gallery height needs to change, change the
           CSS rule, which is the only thing the browser is listening to. */

    /* 0b ── the dots under the image, and the swatch row's scroll cue.
             ⚑ 2026-09-17, with the square hero. The phone thumbnail strip is
             hidden in CSS now, so these dots are the only thing telling a
             shopper there is more than one photo. They are built here rather
             than in Liquid because the count is not known at render time:
             int-variant-gallery.js filters the gallery down to the selected
             colour, so the cell count changes on every swatch click.

             NO LAYOUT SHIFT: the 24px band is reserved in CSS by the grid's
             margin-bottom, in BOTH the critical snippet and int-pdp-mobile.css,
             and this row carries margin-top: -24px. Do not remove one without
             the other.

             This is deliberately NOT a fixed timer schedule. It polls only
             until Flickity exists and the dots are built, then stops, and from
             there Flickity's own `select` event keeps them in step. -------- */
    var intDots = null, intDotsBound = false;

    function intFlkty() {
      var ss = document.querySelector('[data-product-slideshow]');
      var F = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
      return (ss && F && F.data) ? F.data(ss) : null;
    }

    function intSyncDots() {
      if (!intDots) return;
      var f = intFlkty();
      var sel = f ? f.selectedIndex : 0;
      for (var i = 0; i < intDots.children.length; i++) {
        intDots.children[i].classList.toggle('is-on', i === sel);
      }
    }

    function intBuildDots() {
      var grid = q('.product__grid');
      if (!grid) return;
      var f = intFlkty();
      var n = (f && f.cells) ? f.cells.length : grid.querySelectorAll('[data-media-slide]').length;
      if (!intDots) {
        intDots = document.createElement('div');
        intDots.className = 'int-mob-dots';
        grid.parentNode.insertBefore(intDots, grid.nextSibling);
        intDots.addEventListener('click', function (ev) {
          var btn = ev.target && ev.target.closest ? ev.target.closest('.int-mob-dot') : null;
          if (!btn) return;
          var f2 = intFlkty();
          if (f2) f2.select(Number(btn.dataset.i));
        }, false);
      }
      /* One photo is not a gallery. Hidden, not removed, so the reserved band
         stays empty rather than collapsing and moving the page. */
      if (n < 2) { intDots.hidden = true; return; }
      intDots.hidden = false;
      if (intDots.children.length !== n) {
        intDots.textContent = '';
        for (var i = 0; i < n; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'int-mob-dot';
          d.setAttribute('aria-label', 'Photo ' + (i + 1));
          d.dataset.i = String(i);
          intDots.appendChild(d);
        }
      }
      if (f && !intDotsBound) { intDotsBound = true; f.on('select', intSyncDots); }
      intSyncDots();
    }

    /* The swatch row fades whichever end still has colours behind it. The row
       is centred by auto margins in CSS when it fits, so there is nothing to
       fade in that case and the class is removed. */
    function intSwatchScrollState() {
      var list = q('.int-gallery-swatches__list');
      if (!list) return;
      /* 2026-10-26 single-colour-swatch part 2: the arrows either side of a
         10+ colour row (int-gallery-swatches.liquid, .int-gsw-rail). Each one
         is switched off with visibility when its end is reached, never removed,
         so the row does not move. A tap scrolls five swatches (5 x 35px). */
      var prev = q('.int-gsw-arrow--prev'), next = q('.int-gsw-arrow--next');
      var over = list.scrollWidth - list.clientWidth;
      if (prev) prev.classList.toggle('is-off', over <= 2 || list.scrollLeft <= 1);
      if (next) next.classList.toggle('is-off', over <= 2 || list.scrollLeft >= over - 1);
      /* A colour picked from a link can sit past the sixth swatch: bring it
         into the window once, at boot, before anyone looks. */
      if (prev && !list.__intSwInit && over > 2) {
        list.__intSwInit = true;
        var act = list.querySelector('.int-gswatch--active');
        if (act) {
          var lr = list.getBoundingClientRect(), ar = act.getBoundingClientRect();
          if (ar.right > lr.right - 20) {
            list.scrollLeft += (ar.left + ar.width / 2) - (lr.left + lr.width / 2);
          }
        }
      }
      if (prev && !prev.__intSwBound) {
        prev.__intSwBound = next.__intSwBound = true;
        /* Quick taps add up: the next step starts from where the last one
           was going, not from wherever the smooth scroll has got to. */
        var go = function (d) {
          var max = list.scrollWidth - list.clientWidth;
          var base = (list.__intSwT != null && Date.now() - list.__intSwAt < 700) ? list.__intSwT : list.scrollLeft;
          var t = Math.max(0, Math.min(max, base + d));
          list.__intSwT = t; list.__intSwAt = Date.now();
          list.scrollTo({ left: t, behavior: 'smooth' });
        };
        prev.addEventListener('click', function () { go(-175); });
        next.addEventListener('click', function () { go(175); });
      }
      if (over <= 2) {
        list.classList.remove('int-sw-scroll', 'int-sw-start', 'int-sw-end');
        return;
      }
      list.classList.add('int-sw-scroll');
      list.classList.toggle('int-sw-start', list.scrollLeft <= 1);
      list.classList.toggle('int-sw-end', list.scrollLeft >= over - 1);
      if (!list.__intSwBound) {
        list.__intSwBound = true;
        list.addEventListener('scroll', intSwatchScrollState, { passive: true });
      }
    }

    function intGalleryCue() { intBuildDots(); intSwatchScrollState(); }

    document.addEventListener('int:gallery:settled', function () { setTimeout(intGalleryCue, 40); }, false);
    window.addEventListener('resize', function () { setTimeout(intGalleryCue, 140); }, false);
    (function intCuePoll(waited) {
      intGalleryCue();
      var done = intFlkty() && intDots && (intDots.hidden || intDots.children.length);
      if (!done && waited < 12000) setTimeout(function () { intCuePoll(waited + 300); }, 300);
    })(0);

    /* 1 ── the title is NOT MOVED ANY MORE. ---------------------------------
           The order layer in int-pdp-mobile-critical.liquid places it above
           the image in CSS at first paint, and int-pdp-title-fit.js has
           already sized it and released it, both long before this file runs.
           All that is left here is a re-fit, because the buy column's width
           can settle after the webfont and the swatch row have had their say.
           ⚑ Do not put the DOM move back. It is what forced the title to wait
           for 100% of the byte stream. */
    fitTitle(q('.product__block_title .product__title__wrapper'));

    /* Releases the size control's hold in int-pdp-mobile-critical.liquid. The
       TITLE's hold is a different class, int-mob-title-ready, released far
       earlier — see the note in that file. */
    document.body.classList.add('int-mob-ready');

    /* 2 ── size control AND price on one row, in the media column, after
            the swatches. The price block lives in the buy column on desktop,
            so this is a DOM move like the title. ---------------------------- */
    var sizeBox = q('.int-mob-size');
    var priceBlock = q('.product__block__price');
    var swatches = q('#int-gallery-swatches');
    /* ⚑ 2026-09-19 — THE ROW IS SERVER RENDERED NOW, so this is the FALLBACK path.
       snippets/product-price.liquid prints .int-mob-size and .int-price-stack inside
       .product__block__price at parse, and snippets/int-pdp-mobile-critical.liquid
       arranges that block as the row on the FIRST frame. Building the wrapper anyway
       would appendChild the price block out of the buy column after paint, which is
       the 0 -> 34 -> -7 sequence that pass removed: measured y727.83 at t1497,
       y761.83 at t1615, y671.83 at t3023.
       So: if the server already nested the control inside the price block, leave it
       alone. If it did not — a template with no control, or an engine without
       `:has()` — this still runs and int-pdp-mobile.css still styles the wrapper.
       Same shape as mountFit()'s guard and the short subtitle's mount(). */
    if (sizeBox && !(priceBlock && priceBlock.contains(sizeBox))) {
      var row = document.createElement('div');
      row.className = 'int-mob-buyrow';
      row.appendChild(sizeBox);
      if (priceBlock) row.appendChild(priceBlock);
      if (swatches && swatches.parentNode === media) {
        media.insertBefore(row, swatches.nextSibling);
      } else {
        media.appendChild(row);
      }
    }

    /* 3 ── THE READING HALF IS NOT ASSEMBLED HERE ANY MORE. ----------------
           The subtitle, the rating line, the material paragraph and the
           teasers all carry their own `order` in the critical CSS, and
           `.product__block_title` and `.product__headline` are
           `display: contents` below 820px, so those four are already flex
           items of the page column and already in the right place at first
           paint.

           ⚑ THIS IS WHY THERE IS NO DUPLICATE MARKUP. The obvious way to stop
           the title block collapsing from 215px to 46px when the JS pulled
           the subtitle and the material out of it — which would have jerked
           the hero up 169px — was to render a second copy of them further
           down and hide the originals. Flattening the two wrappers instead
           gets the same order with ONE copy of every string, and nothing is
           hidden waiting for a script, so nothing can end up permanently
           invisible if the script fails. */

    /* ── the reveal headline — MOVED OUT ON 2026-09-03 ------------------
       The implementation is assets/int-reveal-lead.js now, loaded by
       sections/product.liquid at every width, and this is a thin call into
       it. It existed twice before — here and, admittedly copied, in
       assets/int-fp-mobile.js — and both files return above 820px, so the
       two headlines existed on phones and nowhere else. Nils asked for them
       on desktop as well, on both templates.
       "Move the call, not the code." Fail visible: if the shared file did not
       load, no headline is inserted at all, rather than an armed one that
       never reveals. */
    function makeLead(text, beforeEl, extraClass, order) {
      if (!window.__intMakeLead) return null;
      return window.__intMakeLead(text, beforeEl, extraClass, order);
    }

    /* 3a ── the headline that opens the reading half. It is inserted next to
             the subtitle so it has a parent to sit in; where it APPEARS is
             decided by its order, not by that position.
             ⚑ 13 -> 16 and, below, 20 -> 21 on 2026-09-05. The subtitle and
             the material paragraph moved up under the delivery panel and
             Styled with Intention moved up under Instagram, which renumbered
             the ladder in snippets/int-pdp-mobile-critical.liquid. These two
             numbers are the same ladder, written here because the elements
             are built here. */
    var subtitleEl = q('.product__block_title .product__subtitle')
                  || q('.product-organic-certification')
                  || q('.int-teasers');
    if (subtitleEl) makeLead(((window.INT_JS_I18N||{}).story)||'The Story continues...', subtitleEl, null, 16);

    /* 3b ── the product reviews, between the buying half and the reading
             half, so that once reviews exist they are what separates them
             (Nils, 2026-09-01).
             ⚑ IT IS A PAGE SECTION, not a child of the buy column, so it is
             the one thing here that still has to be MOVED before it can be
             ordered. Once it is inside the column the critical CSS gives it
             order 12.
             🚨 2026-09-14 — THE HIDE THAT USED TO LIVE HERE WAS A DEADLOCK, AND IT
             MADE EVERY REVIEW INVISIBLE ON A PHONE. It used to add
             `int-mob-rev-empty` (display:none) whenever the app block measured
             empty, re-checking on a MutationObserver and at 500/1500/3000/6000/
             10000 ms. Klaviyo renders into that block LAZILY and will not render
             into a hidden element, and a hidden element always measures
             offsetHeight 0 with no text, so the re-check could never turn false.
             First poll wins, forever.
             Measured live on the draft at 316px with consent GRANTED and 16
             Klaviyo scripts loaded, on a hoodie that has a published 5 star
             review: section `display:none`, `#fulfilled-reviews-all` with ZERO
             children. At 606px the same page filled normally, which is why this
             survived: it only bites at true phone widths.
             ⚑ The hole it was written to prevent no longer exists. Since
             2026-09-14 `sections/apps.liquid` decides server side: a product with
             no review renders NOTHING at all, and a product with no review that
             could have one renders the house "be the first" state. The server
             knows what the JS was guessing at, so the guess is gone.
             ⛔ Do not reintroduce a client side hide here. If a hole ever comes
             back, collapse it in Liquid where the review count is known. */
    var rev = q('[id*="__reviews_klaviyo"]');
    if (rev && inner && rev.parentNode !== inner) {
      inner.appendChild(rev);
      rev.classList.remove('int-mob-rev-empty');
    }

    /* 4 ── THE DELIVERY PANEL IS NOT MOVED ANY MORE EITHER, and neither is
            the pair cross-sell that used to be dragged along behind it.
            Both are children of the buy column, so both are placed by their
            `order` in the critical CSS: delivery at 9, "Complete the set" at
            19, just above the Circle breaker. That retires three JS moves and
            the interval watcher that used to put the cross-sell back after
            the delivery panel had dragged it out of place.
            ⚑ int-pair-crosssell.liquid still does its own move below 767px —
            that is what puts the block INTO this column in the first place,
            and it must stay. Only the reordering here is gone. */
    var pay = q('.int-pay');
    var delivery = q('.int-delivery-estimate');

    /* 🚨 REUSE AN EXISTING HOLDER, NEVER MAKE A SECOND ONE. Added 2026-09-05.
       `.int-mob-fit` now has THREE possible builders: this file on the phone,
       `mountFit()` in assets/int-size-select.js on desktop, and
       `snippets/int-fit-home-inline.liquid`, which is rendered inline in the buy
       column and normally gets there first. `mountFit()` has always opened with
       `if (q('.int-mob-fit')) return;`. This file did NOT, it called
       createElement unconditionally, so once a third builder existed the phone
       would have ended up with TWO holders and the tile in whichever one won the
       race. That is the bug this guard exists to prevent; do not remove it. */
    var fitHome = q('.int-mob-fit');
    if (!fitHome) {
      fitHome = document.createElement('div');
      fitHome.className = 'int-mob-fit';
      /* order 13, under the material paragraph. It is a JS-built element in an
         ordered column, so without this it computes 0 and lands above the
         title. The critical CSS carries the same 13 for the class; this is the
         inline belt to that braces.
         ⚑ 10 -> 13 on 2026-09-05 WITH THE RENUMBER, and it was caught live, not
         reasoned about: the stylesheet said 13 and this line still said 10, so
         the quiz tile computed 10, tied with the subtitle, and landed between
         the subtitle and the material paragraph. ⚑ THREE numbers move together
         now: this line, the stylesheet, and the inline snippet. */
      fitHome.style.order = 13;
      /* Anywhere in the buy column will do — the order value decides where it
         shows. `gr` used to be a third fallback here and its declaration lived
         in the story block that this pass deleted. */
      var fitAfter = delivery || pay || q('.int-product-reviews');
      if (fitAfter && fitAfter.parentNode) {
        fitAfter.parentNode.insertBefore(fitHome, fitAfter.nextSibling);
      } else if (inner) {
        inner.appendChild(fitHome);
      }
    }

    var fitTries = 0;
    var fitTimer = setInterval(function () {
      var box = document.getElementById('fake-fit-quiz');
      var note = document.getElementById('fake-fit-quiz-note');
      if (box && fitHome.parentNode) {
        fitHome.appendChild(box);
        if (note) fitHome.appendChild(note);
        clearInterval(fitTimer);
        return;
      }
      if (++fitTries > 100) clearInterval(fitTimer);
    }, 60);

    /* 4b ── the same breaker again, opening the Circle. Nils, 2026-09-01.
             ⚠️ He typed "In to Philantropy?"; shipped as "Into Philanthropy?"
             — two spelling fixes, flagged to him. Change it back here if that
             was deliberate. */
    (function () {
      var circle = q('.int-circle-note');
      if (circle) makeLead(((window.INT_JS_I18N||{}).philanthropy)||'Into Philanthropy?', circle, 'int-story-lead--circle', 21);
    })();

    /* 5 ── THE SIZE DROPDOWN — MOVED OUT ON 2026-09-03 ----------------
       The wiring now lives in assets/int-size-select.js, loaded by
       sections/product.liquid for apparel at every width. The MARKUP is
       unchanged and still comes from snippets/int-pdp-mobile.liquid.

       ⚑ WHY IT COULD NOT STAY HERE. This file returns at line 24 above 820px,
       so the mirror only ever worked on the phone. Nils asked for the same
       dropdown on desktop, beside the price, so it had to leave a file that
       is mobile-only by construction — the same move zoom made the same day.

       ⚑ DO NOT RE-ADD A COPY. int-size-select.js guards on
       `window.__intSizeSelect`; a second copy would double-bind the change
       handler and click the radios twice. */

    /* 7 ── TAP TO ZOOM — MOVED OUT ON 2026-09-03 ----------------------
       The whole block now lives in assets/int-zoom.js, with its styling in
       assets/int-zoom.css, and both are loaded by sections/product.liquid
       AND sections/product-framedprint.liquid.

       ⚑ WHY IT COULD NOT STAY HERE. This file returns at line 24 above 820px
       (`if (!matchMedia('(max-width: 820px)').matches) return;`), and it is
       only rendered on the apparel template at all. So zoom existed on the
       apparel phone layout and nowhere else. Nils asked for it on framed
       print and on desktop, which means it cannot live inside a file that is
       mobile-and-apparel-only by construction.

       ⚑ DO NOT RE-ADD A COPY HERE. int-zoom.js guards on `window.__intZoom`
       and mounts itself; a second copy would append a second pill.
       "Move the call, not the code." ---------------------------------- */

    /* 6 ── FIND MY SIZE — MOVED OUT ON 2026-09-24 ---------------------
       The click wiring for [data-int-mob-quiz] now lives in
       assets/int-size-select.js, which runs at every width. This file
       returns above 820px, so on desktop the "Find my size" link beside the
       price did nothing. Same move as the size dropdown and zoom.

       ⚑ DO NOT RE-ADD A COPY HERE. int-size-select.js guards on
       `window.__intFindSize`; a second copy would open the quiz twice. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
